import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Constant.js";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  CardHeader,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CommonNavbar from "./CommonLayout/CommonNavbar.js";
import CommonFooter from "./CommonLayout/CommonFooter.js";
import CommonSidebar from "./CommonLayout/CommonSidebar.js";
import "../../App.css";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (event) => {
    if (!validateForm()) return;
    event.preventDefault();

    const data = {
      emailId,
      password,
    };

    try {
      const response = await fetch(API_URL + "api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Login Successful!");

        localStorage.setItem("token", result.token);
        localStorage.setItem("loginId", result.data.loginId);
        localStorage.setItem("userTypeId", result.data.userTypeId);
        localStorage.setItem("firstName", result.data.firstName);
        localStorage.setItem("lastName", result.data.lastName);
        localStorage.setItem("mobileno", result.data.mobileNo);
        localStorage.setItem("emailId", result.data.emailId);
        localStorage.setItem("isDeleted", result.data.isDeleted);

        if (result.data.userTypeId === 1) {
          // Handle Admin login
        } else if (result.data.userTypeId === 2) {
          localStorage.setItem("counselorId", result.data.counselorId); // ✅ Store counselorId
          GoCounsellorNext(result.data.loginId);
        } else {
          GoClientNext(result.data.loginId);
        }
      } else {
        toast.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("An error occurred during login:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const GoClientNext = async (loginId) => {
    try {
      const response = await fetch(
        `${API_URL}api/Login/GetClientNextStepPage/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch course list");
      }

      const data = await response.json();
      navigate(data.result);
    } catch (err) {
    } finally {
    }
  };
  const GoCounsellorNext = async (loginId) => {
    try {
      const response = await fetch(
        `${API_URL}api/Login/GetCounsellorNextStepPage/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch course list");
      }

      const data = await response.json();
      navigate(data.result);
    } catch (err) {
    } finally {
    }
  };

  const validateForm = () => {
    if (!emailId || !password) {
      toast.warn("Please fill in all fields.");
      return false;
    }
    return true;
  };

  return (
    <>
    <CommonNavbar />
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "75vh", backgroundColor: "#f4f4f9" }}
    >
      <Card
        className="mb-4"
        style={{
          width: "90%", // Make it responsive
          maxWidth: "400px", // Limit width on larger screens
          boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
          borderRadius: "16px",
          background: "linear-gradient(145deg, #ffffff, #f3f3f3)",
          padding: "24px",
          border: "none",
        }}
      >
        <h2
          className="text-center mb-4"
          style={{
            color: "#333",
            fontSize: "1.8rem",
            fontWeight: "400",
            textTransform: "uppercase",
          }}
        >
          Login
        </h2>

        <CardBody>
          {/* Email Field */}
          <FormGroup>
            <InputGroup className="mb-4">
              <InputGroupText
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ccc",
                  borderRadius: "3px 0 0 3px",
                }}
              >
                <FaEnvelope style={{ color: "#777" }} />
              </InputGroupText>
              <Input
                type="email"
                placeholder="Email or Username"
                value={emailId}
                onChange={(e) => setEmailId(e.target.value)}
                required
                style={{
                  fontSize: "1rem",
                  padding: "20px",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                  borderRadius: "0 3px 3px 0",
                  backgroundColor: "#f8f9fa",
                }}
              />
            </InputGroup>
          </FormGroup>

          {/* Password Field */}
          <FormGroup>
            <InputGroup className="mb-4">
              <InputGroupText
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ccc",
                  borderRadius: "3px 0 0 3px",
                }}
              >
                <FaLock style={{ color: "#777" }} />
              </InputGroupText>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  fontSize: "1rem",
                  padding: "20px",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                  borderRadius: "0 0px 0px 0",
                  backgroundColor: "#f8f9fa",
                }}
              />
              <InputGroupText
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  borderRadius: "0 3px 3px 0",
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <FaEyeSlash style={{ color: "#777" }} />
                ) : (
                  <FaEye style={{ color: "#777" }} />
                )}
              </InputGroupText>
            </InputGroup>
          </FormGroup>

          {/* Login Button */}
          <center><Button
            color="primary"
            size="sm"
            onClick={handleSubmit}
            style={{
              fontSize: "1.2rem",
              borderRadius: "3px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              transition: "background 0.3s ease",
              background: "#007bff",
              border: "none",
              width:"40%",
            }}
            onMouseEnter={(e) => (e.target.style.background = "#0056b3")}
            onMouseLeave={(e) => (e.target.style.background = "#007bff")}
          >
            Login
          </Button></center>

          {/* Forgot Password */}
          <div className="text-center mt-3">
            <small>
              <a
                href="/forgot-password"
                style={{
                  color: "#007bff",
                  textDecoration: "none",
                  fontWeight: "500",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
                onMouseLeave={(e) => (e.target.style.color = "#007bff")}
              >
                Forgot Password?
              </a>
            </small>
          </div>
        </CardBody>
      </Card>
    </div>
    <CommonFooter/>
    </>
  );
};

export default Login;
